import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions, MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import {
    AUTOCOMPLETE_FROM_MASTER_DATA,
    AUTOCOMPLETEFROMENUMERATION_COLUMN_URI,
    AUTOCOMPLETEFROMURI_COLUMN_URI,
    AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI,
    CHECKBOX_COLUMN_URI,
    CODEBAR_SCANNER_URI,
    CODEBARSCANNERWITHSELECT_URI,
    DATEPICKER_COLUMN_URI,
    DeleteDTypeData,
    DType,
    DTypeCol,
    DTypeRepository,
    DTypeStatus, INTEGER_COLUMN_URI, LANGUAGETEXT_COLUMN_URI, Pagination,
    RADIO_COLUMN_URI,
    RATING_COLUMN_URI,
    REAL_COLUMN_URI,
    SELECTFACADE_COLUMN_URI,
    SELECTFROMCONCEPTSERVICE_COLUMN_URI,
    SELECTFROMENUMERATION_COLUMN_URI,
    SELECTFROMMASTERDATA_COLUMN_URI, SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI, SELECTFROMURI_COLUMN_URI,
    SELECTMASTER_COLUMN_URI,
    SELECTNEXTTASKTYPE_COLUMN_URI,
    SELECTSERVICE_COLUMN_URI,
    SELECTSERVICEUSERASSIGNMENT_COLUMN_URI,
    SELECTWITHGIVENOPTIONS_COLUMN_URI,
    TEXT_COLUMN_URI,
    TIMEPICKER_COLUMN_URI,
    TIMERANGESCONVERTER_COLUMN_URI,
    TRISTATE_COLUMN_URI
} from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
// import { UserNodePrivileges } from 'app/modules/admin/projects/projects.types';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { addDays, format, startOfToday, subDays } from 'date-fns';
import * as lodash from 'lodash-es';
import { BehaviorSubject, catchError, combineLatest, debounceTime, firstValueFrom, map, Subject, takeUntil, throwError } from 'rxjs';
import { MasterService } from '../master.service';
import { DownloadMasterXSSFBody, MasterData, UploadMasterXSSFBody, UploadMasterXSSFResponse } from '../master.types';
import { LocalizeDatePipe } from '../../pipes/localizeDate.pipe';
import { LocalizePipe } from '../../pipes/standalone/localize.pipe';
import { DtypeItemComponent } from '../../dtype/dtype-item/dtype-item.component';
import { DtypeFilterComponent } from '../../dtype/dtype-filter/dtype-filter.component';
import { DTypeAlerts, Net2BeepleLocator } from '../../dtype/dtype.types';
import { UserNodePrivileges } from '../../../modules/admin/endpoints/endpoints.types';
import { DialogsService } from '../../../dialogs/dialogs.service';
import { DTypeService } from '../../dtype/dtype.service';
import { LocalizeService } from '../../pipes/localize.service';
import { EndpointsService } from '../../../modules/admin/endpoints/endpoints.service';
import { UserService } from '../../user/user.service';
import { FuseConfirmationService } from '../../../../@fuse/services/confirmation/confirmation.service';
import { FileService } from '../../file/file.service';
import { RetrieveDTypeDataCollectionRequest, SearchDTypeDataCollection } from '../../http/request.model';
import { ConfirmationWithCheckConfig } from '../../../dialogs/confirm-with-check-dialog/confirm-with-check-dialog.types';
import { Utils } from '../../utils/utils';

export const UPLOAD_MASTER_EXCEL_URI = 'excelupload://com.cloudcodice.thirdparty.grupoconstant.poixssf.DTypeExcelMasterUpload';
@Component({
    selector: 'master-data',
    templateUrl: './master-data.component.html',
    providers: [
        { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions },
        LocalizeDatePipe
    ],
    styles: [
        /* language=SCSS */
        `
            ::ng-deep .my-menu {
                max-width: none;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, LocalizePipe, MatMenuModule, forwardRef(() => DtypeItemComponent), MatPaginatorModule, MatSortModule, MatIconModule,
    MatButtonModule, MatSlideToggleModule, MatInputModule, MatCheckboxModule, MatProgressBarModule, MatDatepickerModule, MatFormFieldModule,
    MatTooltipModule, RouterModule, FormsModule, ReactiveFormsModule, DtypeFilterComponent]
})
export class MasterDataComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(MatSort) _sort: MatSort;
    @ViewChild(MatPaginator) _paginator: MatPaginator;

    masterData: MasterData;

    params: Params;
    uri: string;
    locator: Net2BeepleLocator;
    repo: DTypeRepository;
    sameLocator: boolean;
    role: UserNodePrivileges;
    canModifyData = false;

    showAlerts: DTypeAlerts = {
        showScheduleToGoLive: true,
        showMigrating: true,
        showHasRequestToGoLive: true,
    };

    scheduleAlert: string;

    databaseViewMode: boolean;
    ordering = false;
    orderingSnapshot: any[] = [];

    masterForm: DTypeForm;
    loading = true;
    fileLoading = false;

    columns: DTypeCol[];
    items$ = new BehaviorSubject([]);
    filteredItems$ = new BehaviorSubject([]);
    visibleItems$ = new BehaviorSubject([]);

    //paginator
    pageSize = 10;
    pageSizeOptions = [5, 10, 20, 50];
    pagination: Pagination = {
        page: 0,
        size: this.pageSize,
        length: 0,
        startIndex: 0,
        endIndex: 0,
        lastPage: 0
    };
    totalLength = 0;
    eof = false;
    disabledSort = false;

    oidsLocationChangePending: string[] = [];
    filterLocationChangePending = false;

    //selection
    allSelected = false;
    someSelected = false;
    numSelected = 0;

    //search
    readonly debounceTime = 400;
    searchControl = new FormControl('');
    filteredTotalLength = 0;
    filteredEof = false;

    //filters
    filterDTypeForm: DTypeForm;
    hasFilter = false;
    showFilters = false;

    //compact
    compact = false;

    includeDeprecated = true;
    dateForm: FormGroup;
    periodsDate = startOfToday();

    readonly columnTypesOrdered = [
        AUTOCOMPLETEFROMENUMERATION_COLUMN_URI,
        AUTOCOMPLETEFROMURI_COLUMN_URI,
        AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI,
        AUTOCOMPLETE_FROM_MASTER_DATA,
        CHECKBOX_COLUMN_URI,
        CODEBARSCANNERWITHSELECT_URI,
        CODEBAR_SCANNER_URI,
        DATEPICKER_COLUMN_URI,
        INTEGER_COLUMN_URI,
        RADIO_COLUMN_URI,
        RATING_COLUMN_URI,
        LANGUAGETEXT_COLUMN_URI,
        REAL_COLUMN_URI,
        SELECTFACADE_COLUMN_URI,
        SELECTFROMCONCEPTSERVICE_COLUMN_URI,
        SELECTFROMENUMERATION_COLUMN_URI,
        SELECTFROMMASTERDATA_COLUMN_URI,
        SELECTFROMURI_COLUMN_URI,
        SELECTMASTER_COLUMN_URI,
        SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI,
        SELECTNEXTTASKTYPE_COLUMN_URI,
        SELECTSERVICE_COLUMN_URI,
        SELECTSERVICEUSERASSIGNMENT_COLUMN_URI,
        SELECTWITHGIVENOPTIONS_COLUMN_URI,
        TEXT_COLUMN_URI,
        TIMEPICKER_COLUMN_URI,
        TIMERANGESCONVERTER_COLUMN_URI,
        TRISTATE_COLUMN_URI
    ];

    private readonly chunksize = 100;

    private initialized = new Subject<void>();
    private _unsubscribeAll = new Subject<void>();
    private isSystemConfig: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private dialog: DialogsService,
        private dtypeService: DTypeService,
        private localize: LocalizeService,
        private localizeDate: LocalizeDatePipe,
        private masterService: MasterService,
        private endpointsService: EndpointsService,
        private router: Router,
        private transloco: TranslocoService,
        private userService: UserService, // TODO: Probablemente haya que borrar porque no hace falta gestionar permisos
        private snackbar: MatSnackBar,
        private _fuseConfirmationService: FuseConfirmationService,
        private fileService: FileService
    ) { }

    ngOnInit() {
        this.dateForm = new FormGroup({
            periodsDate: new FormControl<Date>(startOfToday(), Validators.required),
        });
        combineLatest([this.activatedRoute.url, this.activatedRoute.queryParams]).pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(async ([url, params]) => {
            if (params && this.uri && params.uri === this.uri) {
                return;
            }
            this.loading = true;

            this.databaseViewMode = params.databaseViewMode ?? false;
            this.databaseViewMode = false;
            this.params = params;
            this.isSystemConfig = url[0].path === 'masterSystem';

            this.role = this.endpointsService.getRoleByParams(params);

            if (this.isSystemConfig) {
                if (!this.role?.systemConfig) {
                    this.router.navigateByUrl('/403');
                }
            }

            // if (!this.role.masterDataManagement) {
            //     this.router.navigateByUrl('/403');
            // }

            if (params.uri && params.locator) {
                this.uri = params.uri;
                this.masterService.setMasterUri(this.uri);
                this.locator = this.masterService.getLocatorFromString(this.uri.substring(9, this.uri.lastIndexOf('/'))); //master://
                this.repo = lodash.cloneDeep(await firstValueFrom(this.masterService.retrieveMasterDataDTypeRepositoryByUri(this.uri, DTypeStatus.LIVE, this.locator)));
                this.masterData = this.repo.payload as MasterData;
                this.canModifyData = this.role?.masterDataManagement;
                this.dateForm.get('periodsDate').setValue(this.masterData?.validity === 'PERIOD' ? startOfToday() : undefined);
                this.masterService.setMasterCaption(this.masterData.caption);
                this.sameLocator = this.isTheSameLocator(params.locator, this.repo.belongsTo);
            } else {
                this.dialog.openErrorDialog();
                this.router.navigate(['/endpoints'], { queryParams: { force: true } });
                return;
            }

            if (this.repo.dtypeToGoLiveSchedule && !this.repo.migrating) {
                this.calculateScheduleAlert();
            }

            // this.columns = this.masterData.columnsForList.map(columnKey => this.masterData.column.find(column => column.name === columnKey));

            this.columns = [];
            this.columns = this.masterData.columnsForList
                .map(columnKey => this.masterData.column.find(column => column.name === columnKey))
                .filter(column => Boolean(column));

            this.filterDTypeForm =  this.dtypeService.getExternalFilterDtypeFormFromDtype(this.masterData);
            this.filterDTypeForm?.control?.valueChanges
            .pipe(
                debounceTime(this.debounceTime),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => this.search());
            this.hasFilter = this.filterDTypeForm? true : false;

            //if no visible columns show them all
            if (this.columns.length === 0) {
                this.columns = this.masterData.column.filter(c => this.masterData.availableColumnsForList.includes(c.name));
            }


            this.masterForm = await this.masterService.retrieveMasterDataDtypeForm(this.masterData, { isUpdate: true });

            const sortableColumns = this.columns.filter(c => !this.isSortDisabledForTheColumn(c));
            //get items from server
            const request: RetrieveDTypeDataCollectionRequest = {
                uri: this.masterData.uri,
                count: true,
                columnsForList: false,
                chunksize: this.chunksize,
                orderBy: this.masterData.isManualOrder ? '_masterOrder' : sortableColumns.length > 0 ? sortableColumns[0].name : undefined,
                discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                     ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
            };
            this.retrieveMasterData(request).subscribe((items) => {
                if (items) {
                    this.initialized.next();
                    this.initialized.complete();
                    this.items$.next(items);
                    this.filteredItems$.next(items);
                }
                this.loading = false;
            });

            //reset search value
            this.searchControl.setValue('', { emitEvent: false });

            this._changeDetectorRef.detectChanges();
        });

        //sets visible items as the items 0 to pageSize-1
        this.filteredItems$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((items) => {
                const column = this.columns?.find(c => c.name === this._sort?.active);
                const viewItems = this.masterService.getViewItems(items, 
                    this.isSearching() ? this.filteredTotalLength : this.totalLength,
                    this._paginator?.pageIndex, this._paginator?.pageSize);
                this.pagination = viewItems.pagination as Pagination;
                this.visibleItems$.next(viewItems.list);
            });

        //init search observable
        this.searchControl.valueChanges
            .pipe(
                debounceTime(this.debounceTime),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => this.search());

        this.dateForm.get('periodsDate').valueChanges.subscribe(() => {
            if (this.masterData && this.columns){
                this.deprecatedChanged();
            }
        });
    }

    ngOnDestroy() {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    async ngAfterViewInit() {
        this.initialized.subscribe({
            complete: () => {
                this._changeDetectorRef.detectChanges();
                if (this._sort && this._paginator) {
                    // Set the initial sort
                    const sortableColumns = this.columns.filter(c => !this.isSortDisabledForTheColumn(c));
                    if (this.masterData.isManualOrder) {
                        this._sort.sort({
                            id: '_masterOrder',
                            start: 'asc',
                            disableClear: false,
                        });
                    } else if (sortableColumns.length > 0) {
                        this._sort.sort({
                            id: sortableColumns[0].name,
                            start: 'asc',
                            disableClear: false,
                        });
                    }
                    // Mark for check
                    this._changeDetectorRef.markForCheck();

                    // If the user changes the sort order...
                    this._sort.sortChange
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe(() => {
                            this.loading = true;
                            // Reset back to the first page
                            this._paginator.pageIndex = 0;
                            const column = this.columns.find(c => c.name === this._sort?.active);
                            //get items from server
                            const request: RetrieveDTypeDataCollectionRequest = {
                                uri: this.masterData.uri,
                                count: true,
                                columnsForList: false,
                                chunksize: this.chunksize,
                                orderBy: `${column.name} ${this._sort.direction.toUpperCase()}`,
                                discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                                deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                                    ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
                            };
                            this.retrieveMasterData(request).subscribe((items) => {
                                if (items) {
                                    this.items$.next(items);
                                    this.filteredItems$.next(items);
                                }
                                this.loading = false;
                            });
                        });

                    this._paginator.page
                        .pipe(
                            takeUntil(this._unsubscribeAll),
                            map(() => {
                                const column = this.columns.find(c => c.name === this._sort?.active);
                                const items = this.filteredItems$.getValue();
                                const searching = this.isSearching();
                                if (this._paginator.pageIndex * this._paginator.pageSize >= items.length) {
                                    if (!searching) {
                                        //get items from server
                                        const request: RetrieveDTypeDataCollectionRequest = {
                                            uri: this.masterData.uri,
                                            count: true,
                                            columnsForList: false,
                                            chunksize: this.chunksize,
                                            orderBy: `${column.name} ${this._sort.direction.toUpperCase()}`,
                                            lastConsumedOID: items[items.length -1]._oid,
                                            discardDeprecated: !this.includeDeprecated
                                        };
                                        this.retrieveMasterData(request).subscribe((newItems) => {
                                            if (newItems) {
                                                const oldItems = this.items$.getValue();
                                                oldItems.push(...newItems);
                                                this.items$.next(oldItems);
                                                this.filteredItems$.next(oldItems);
                                            }
                                            this.loading = false;
                                        });
                                    } else {
                                        const body: SearchDTypeDataCollection = {
                                            uri: this.masterData.uri,
                                            expr: this.searchControl.value,
                                            attributeFilters: this.filterDTypeForm?.control?.value,
                                            count: true,
                                            chunksize: this.chunksize,
                                            lastConsumedOID: items[items.length -1]._oid,
                                            discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined :
                                                !this.includeDeprecated,
                                            searchDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                                                ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
                                        };
                                        this.masterService.searchData(body).pipe(
                                            catchError((error) => {
                                                console.error(error);
                                                this.dialog.openErrorDialog();
                                                this.loading = false;
                                                return throwError(() => error);
                                            }),
                                            map((reply) => {
                                                this.filteredTotalLength = reply.count ?? 0;
                                                this.filteredEof = reply.eof;
                                                const data = reply?.data ?? [];
                                                for (const item of data) {
                                                    (item as any).form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType,
                                                        item, { isUpdate: true });
                                                    item['selected'] = false;
                                                }
                                                return data;
                                            }),
                                        ).subscribe((newItems) => {
                                            if (newItems) {
                                                const oldItems = this.filteredItems$.getValue();
                                                oldItems.push(...newItems);
                                                this.filteredItems$.next(oldItems);
                                            }
                                            this.loading = false;
                                        });
                                    }
                                } else {
                                    const viewItems = this.masterService.getViewItems(items, searching ? this.filteredTotalLength : this.totalLength,
                                        this._paginator.pageIndex, this._paginator.pageSize);
                                    this.pagination = viewItems.pagination as Pagination;
                                    this.visibleItems$.next(viewItems.list);
                                }
                            })
                        ).subscribe();
                }
            }
        });
    }

    toggleFilters() {
        this.showFilters = !this.showFilters;
    }

    async startOrdering() {
        this.clearSearch();
        this.searchControl.disable({ emitEvent: false });
        const items = this.filteredItems$.getValue();
        items.forEach(item => item.selected = false);
        this.calculateSelectionStatus();
        if (this.filterLocationChangePending) {
            this.filterLocationChangePending = false;
            this.toggleLocationChangePending();
        }
        if (!this.includeDeprecated) {
            this.includeDeprecated = true;
            await this.deprecatedChanged();
        }
        this.orderingSnapshot = lodash.cloneDeep(this.items$.getValue());
        this.visibleItems$.next(this.items$.getValue());
        this.ordering = true;
    }

    cancelOrdering() {
        this.searchControl.enable();
        this.items$.next(this.orderingSnapshot);
        this.orderingSnapshot = undefined;
        this.ordering = false;
    }

    async saveOrdering() {
        try {
            const items = lodash.cloneDeep(this.visibleItems$.getValue());
            items.forEach(item => {
                delete item.form;
                delete item.selected;
            });
            await firstValueFrom(this.dtypeService.flushMasterOrder({ oids: items.map(i => i._oid), uri: this.repo.uri }));
            this.searchControl.enable();
            this.items$.next(this.visibleItems$.getValue());
            this.orderingSnapshot = undefined;
            this.ordering = false;
        } catch (error) {
            console.error(error);
            this.dialog.openErrorDialog({
                message: error?.error?.echo ? this.localize.transform(error?.error?.echo) : undefined,
            });
        }
    }

    moveRow(event: PointerEvent, direction: 'up' | 'down', index: number) {
        event.stopPropagation();
        const items = this.items$.getValue();
        const aux = items[index];
        if (direction === 'up') {
            items[index] = items[index - 1];
            items[index - 1] = aux;
        } else if (direction === 'down') {
            items[index] = items[index + 1];
            items[index + 1] = aux;
        }
    }

    isSortDisabledForTheColumn(column: DTypeCol) {
        return !this.columnTypesOrdered.includes(column.type);
    }

    newItem() {
        this.dialog.openDtypeMasterDataDialog(this.masterData).afterClosed().subscribe(async (newItem) => {
            if (newItem) {
                this.loading = true;
                // Reset back to the first page
                this._paginator.pageIndex = 0;
                const column = this.columns.find(c => c.name === this._sort?.active);
                //get items from server
                const searching = this.isSearching();
                if (!searching) {
                    await firstValueFrom(this.masterService.searchData({
                        uri: this.masterData.uri,
                        expr: '',
                        reload: true
                    }));
                    const request: RetrieveDTypeDataCollectionRequest = {
                        uri: this.masterData.uri,
                        count: true,
                        columnsForList: false,
                        chunksize: this.chunksize,
                        orderBy: `${column.name} ${this._sort.direction.toUpperCase()}`,
                        discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                        deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                            ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
                    };
                    this.retrieveMasterData(request).subscribe((items) => {
                        if (items) {
                            this.items$.next(items);
                            this.filteredItems$.next(items);
                        }
                        this.calculateSelectionStatus();
                        this.loading = false;
                    });
                } else {
                    this.search(true);
                }
            }
        });
    }

    editItem(item: any) {
        if (this.ordering) {
            return;
        }
        this.dialog.openDtypeMasterDataDialog(this.masterData, item, !this.canModifyData).afterClosed()
            .subscribe(async (editedItem) => {
                if (editedItem) {
                    await firstValueFrom(this.masterService.searchData({
                        uri: this.masterData.uri,
                        expr: '',
                        reload: true
                    }));
                    const items = this.filteredItems$.getValue();
                    const primaryKeys = this.masterData.index.find(index => index.unique).column;

                    const itemToEditIndex = items.findIndex(i => primaryKeys.every(pk => i[pk] === editedItem[pk]));
                    editedItem.form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType, editedItem, { isUpdate: true });
                    items[itemToEditIndex] = editedItem;
                    this.filteredItems$.next(items);
                    this._changeDetectorRef.markForCheck();
                }
            });
    }

    async removeItems(): Promise<void> {
        const confirm = await this.confirm();
        if (confirm === 'checked' || confirm === 'confirmed') {
            const itemsToRemove = this.filteredItems$.getValue()
                .filter(item => item.selected)
                .map(item => item.form.control.getRawValue());
            const body: DeleteDTypeData = {
                uri: this.masterData.uri,
                data: itemsToRemove.map(item => ({ '_oid': item._oid })),
            };
            if (confirm === 'checked') {
                body.isPhysicalDelete = true;
            }
            this.masterService.deleteData(body)
                .subscribe(async (response) => {
                    if (!response.error) {
                        this.loading = true;
                        // Reset back to the first page
                        this._paginator.pageIndex = 0;
                        const column = this.columns.find(c => c.name === this._sort?.active);
                        //get items from server
                        const searching = this.isSearching();
                        if (!searching) {
                            await firstValueFrom(this.masterService.searchData({
                                uri: this.masterData.uri,
                                expr: '',
                                reload: true
                            }));
                            const request: RetrieveDTypeDataCollectionRequest = {
                                uri: this.masterData.uri,
                                count: true,
                                columnsForList: false,
                                chunksize: this.chunksize,
                                orderBy: `${column.name} ${this._sort.direction.toUpperCase()}`,
                                discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                                deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                                    ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
                            };
                            this.retrieveMasterData(request).subscribe((items) => {
                                if (items) {
                                    this.items$.next(items);
                                    this.filteredItems$.next(items);
                                }
                                this.calculateSelectionStatus();
                                this.loading = false;
                            });
                        } else {
                            this.search(true);
                        }
                    }
                });
        }
    }

    updateSelection(item, event): void {
        event.stopPropagation();
        const items = this.filteredItems$.getValue();
        const index = items.findIndex(i => i._oid === item._oid);
        item.selected = !item.selected;
        if (index > -1) {
            items[index] = item;
        }
        this.filteredItems$.next(items);
        this.calculateSelectionStatus();
    }

    selectAll(event): void {
        event.stopPropagation();
        const items = this.filteredItems$.getValue();
        items.forEach(item => item.selected = !this.allSelected);
        this.filteredItems$.next(items);
        this.calculateSelectionStatus();
    }


    search(modified = false) {
        if (!this.isSearching()) {
            this.clearSearch();
            return;
        }
        const body: SearchDTypeDataCollection = {
            uri: this.masterData.uri,
            expr: this.searchControl.value,
            attributeFilters: this.filterDTypeForm?.control?.value,
            count: true,
            chunksize: this.chunksize,
            reload: modified,
            discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
            searchDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
        };

        this.loading = true;
        this.filterLocationChangePending = false;
        this.masterService.searchData(body).pipe(
            catchError((error) => {
                console.error(error);
                this.dialog.openErrorDialog();
                this.loading = false;
                return throwError(() => error);
            }),
            map((reply) => {
                this.filteredTotalLength = reply.count ?? 0;
                this.filteredEof = reply.eof;
                const data = reply?.data ?? [];
                for (const item of data) {
                    (item as any).form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType, item, { isUpdate: true });
                    item['selected'] = false;
                }
                return data;
            }),
        ).subscribe((result) => {
            // Reset back to the first page
            this._paginator.pageIndex = 0;
            this.disabledSort = true;
            this.filteredItems$.next(result);
            this.loading = false;
        });
        this.calculateSelectionStatus();
    }

    clearSearch(): void {
        this.searchControl.setValue('', { emitEvent: false });
        this.disabledSort = false;
        this.filteredTotalLength = 0;
        this.filteredEof = false;
        if (this._paginator) {
            this._paginator.pageIndex = 0;
        }
        const items = this.items$.getValue();
        items.forEach(item => item['selected'] = false);
        this.filteredItems$.next(items);
        this.calculateSelectionStatus();
    }

    isLocationPending(oid: string) {
        return this.oidsLocationChangePending.includes(oid);
    }

    toggleLocationChangePending() {
        this.loading = true;
        this.clearSearch();
        if (this.oidsLocationChangePending.length === 0) {
            this.filterLocationChangePending = false;
        }
        if (this.filterLocationChangePending) {
            this.masterService.retrieveLocationChangeRequest({
                oids: this.oidsLocationChangePending,
                includeMasterData: true,
                includeRequestData: this.oidsLocationChangePending.length > 20 ? false : true
            }).pipe(
                catchError((error) => {
                    console.error(error);
                    this.dialog.openErrorDialog();
                    this.loading = false;
                    return throwError(() => error);
                }),
                map((reply) => {
                    if (reply) {
                        for (const item of reply.masterData ?? []) {
                            item['selected'] = false;
                            item.form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType, item, { isUpdate: true });
                        }
                        if (reply.requestData) {
                            for (const request of reply.requestData) {
                                const item = (reply.masterData ?? []).find(m => m._oid === request.oid);
                                if (item) {
                                    item.requestData = request;
                                }
                            }
                        }
                        return reply.masterData ?? [];
                    }
                }),
            ).subscribe((items) => {
                this.totalLength = items.length;
                this.eof = true;
                this.items$.next(items);
                this.filteredItems$.next(items);
                this.loading = false;
            });
        } else {
            const sortableColumns = this.columns.filter(c => !this.isSortDisabledForTheColumn(c));
            const request: RetrieveDTypeDataCollectionRequest = {
                uri: this.masterData.uri,
                count: true,
                columnsForList: false,
                chunksize: this.chunksize,
                orderBy: this.masterData.isManualOrder ? '_masterOrder' : sortableColumns.length > 0 ? sortableColumns[0].name : undefined,
                discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                     ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
            };
            this.retrieveMasterData(request).subscribe((items) => {
                if (items) {
                    this.initialized.next();
                    this.initialized.complete();
                    this.items$.next(items);
                    this.filteredItems$.next(items);
                }
                this.loading = false;
            });
        }
    }

    openChangeLocationModal(event: PointerEvent, item: any) {
        event.stopPropagation();
        const dialog = this.dialog.openLocationChangeDialog(item);
        dialog.afterClosed().subscribe((result: 'approve' | 'reject') => {
            if (result !== undefined) {
                this.masterService.flushLocationChangeResult(item._oid, result === 'approve').pipe(
                    catchError((error) => {
                        console.error(error);
                        this.dialog.openErrorDialog();
                        this.loading = false;
                        return throwError(() => error);
                    }),
                ).subscribe(() => {
                    const oidIndex = this.oidsLocationChangePending.findIndex(oid => oid === item._oid);
                    if (oidIndex > -1) {
                        this.oidsLocationChangePending.splice(oidIndex);
                    }
                    this.toggleLocationChangePending();
                    this.snackbar.open(this.transloco.translate(result === 'approve' ? 'approveChangeLocationSuccess' : 'rejectChangeLocationSuccess'), this.transloco.translate('accept'), { duration: 5000 });
                });
            }
        });
    }

    changeView() {
        this.databaseViewMode = !this.databaseViewMode;
    }

    async notifySystemChanges() {
        const confirm = await this.confirmationDialog('confirmNotifySystemChanges');
        if (confirm) {
            await firstValueFrom(this.masterService.notifySystemChangesForUsers());
        }
    }

    async downloadMaster() {
        const date = (format(new Date(), 'yyyy-MM-dd_HH-mm-ss'));
        const filenameFront = this.localize.transform(this.masterData?.name) + '_r_' + this.repo.release + '_d_' + date;
        const body: DownloadMasterXSSFBody = { uri: this.uri, language: this.transloco.getActiveLang() };
        this.masterService.downloadMasterXSSF(body).pipe(
            catchError((error) => {
                console.error(error);
                let _message = null;
                if (error?.status === 404) {
                    _message = 'No se ha encontrado el repositorio.';
                }
                if (error?.status === 403) {
                    _message = 'El maestro contiene campos no soportados para descarga en excel.';
                }
                this.dialog.openErrorDialog({
                    message: _message ? _message : undefined,
                });
                return throwError(() => error);
        })).subscribe((data) => {
            const filename = String(data?.headers?.get('content-disposition')).replace('attachment; filename="', '').replace('"', '');
            const element = document.createElement('a');
            element.href = window.URL.createObjectURL(data.body);
            element.download = filename ?? filenameFront;
            element.click();
        });
    }

    uploadMaster($event, keepOriginalData: boolean, _async: boolean) {
        this.fileLoading = true;
        const file = $event?.target?.files[0] ?? undefined;
        $event.stopPropagation();
        let base64: string;
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                base64 = String(reader.result);
                const body: UploadMasterXSSFBody = {
                    uri: this.uri,
                    release: this.repo.release,
                    base64: base64,
                    forceUpload: true,
                    async: _async,
                    keepOriginalData: keepOriginalData
                };
                this.masterService.uploadMasterXSSF(body).pipe(
                    catchError((error) => {
                        console.error(error);
                        this.dialog.openErrorDialog({
                            message: error?.error?.echo ? this.localize.transform(error?.error?.echo) : undefined,
                        });
                        this.fileLoading = false;
                        return throwError(() => error);
                    })
                ).subscribe(async (data) => {
                    this.showUploadMasterResponse(data);
                });
            };
        } else {
            this.fileLoading = false;
        };
    }

    // hasPermissionToDesignRepository() {
    //     return this.projectsService.hasPermissionToDesignRepository(this.role, 'master');
    // }

    clearDate() {
        if (this.dateForm.get('periodsDate').value !== undefined) {
            this.dateForm.get('periodsDate').setValue(undefined);
        }
    }

    previousDay() {
        this.dateForm.get('periodsDate').setValue(subDays(this.dateForm.get('periodsDate').value, 1));
    }

    nextDay() {
        this.dateForm.get('periodsDate').setValue(addDays(this.dateForm.get('periodsDate').value, 1));
    }

    openDatepicker(datepicker: MatDateRangePicker<Date>) {
        if (!datepicker.opened) {
            datepicker.open();
        }
    }

    async cancelQuarantine() {
        const confirm2 = await this.openConfirmDialogWithCountdown(
            this.transloco.translate('quarantineReject.title'),
            this.transloco.translate('quarantineReject.message'),
            this.transloco.translate('quarantineReject.countdownMessage'));
        if (confirm2) {
            this.dtypeService.flushDTypeToGoLiveSchedule({uri: this.uri, rejected: true}).pipe(
                catchError((error) => {
                    this.dialog.openErrorDialog({
                        message: error?.error?.echo ? this.localize.transform(error?.error?.echo) : undefined,
                    });
                    console.error(error);
                    return throwError(() => error.error);
                }),
                map(reply => reply.repository)
            ).subscribe(async (repo) => {
                this.repo = repo;
                this.masterData = repo.payload as MasterData;
            });
        }
    }

    async searchCacheRefresh() {
        const confirm = await this.confirmationDialog('searchCacheRefreshMessage');
        if (confirm) {
            const body: SearchDTypeDataCollection = {
                uri: this.masterData.uri,
                expr: '',
                reload: true,
            };
            this.loading = true;
            this.masterService.searchData(body).pipe(
                catchError((error) => {
                    console.error(error);
                    this.dialog.openErrorDialog();
                    this.loading = false;
                    return throwError(() => error);
                })).subscribe(() => {
                    this.snackbar.open(this.transloco.translate('searchCacheRefreshDone'), this.transloco.translate('accept'), { duration: 5000 });
                    this.loading = false;
            });
        }
    }

    async deprecatedChanged() {
        // Reset back to the first page
        this._paginator.pageIndex = 0;
        const column = this.columns.find(c => c.name === this._sort?.active);
        //get items from server
        const searching = this.isSearching();
        if (!searching) {
            const request: RetrieveDTypeDataCollectionRequest = {
                uri: this.masterData.uri,
                count: true,
                columnsForList: false,
                chunksize: this.chunksize,
                orderBy: `${column.name} ${this._sort.direction.toUpperCase()}`,
                discardDeprecated: this.masterData?.validity === 'PERIOD' ? this.dateForm.get('periodsDate').value !== undefined : !this.includeDeprecated,
                deprecatedDate: this.masterData?.validity === 'PERIOD' && this.dateForm.get('periodsDate').value !== undefined
                    ? format(this.dateForm.get('periodsDate').value, 'yyyy-MM-dd') : null
            };
            this.retrieveMasterData(request).subscribe((items) => {
                if (items) {
                    this.items$.next(items);
                    this.filteredItems$.next(items);
                }
                this.calculateSelectionStatus();
                this.loading = false;
            });
        } else {
            this.search();
        }
    }

    private async showUploadMasterResponse(data: UploadMasterXSSFResponse) {
        if (data && data?.async && data?.status === 202) {
            this.snackbar.open(this.transloco.translate('excelDataProcessAsync'), this.transloco.translate('accept'), { duration: 5000 });
            this.fileLoading = false;
        } else if (data && data?.status === 200) {
            const sortableColumns = this.columns.filter(c => !this.isSortDisabledForTheColumn(c));
            this.masterService.retrieveMasterDataDataCollection({
                uri: this.masterData.uri,
                count: true,
                columnsForList: false,
                chunksize: this.chunksize,
                orderBy: sortableColumns.length > 0 ? sortableColumns[0].name : undefined,
                discardDeprecated: !this.includeDeprecated
            })
                .pipe(
                    catchError((error) => {
                        console.error(error);
                        this.dialog.openErrorDialog();
                        this.loading = false;
                        return throwError(() => error);
                    }),
                    map((reply) => {
                        if (reply) {
                            this.totalLength = reply.count ?? 0;
                            this.eof = reply.eof;
                            for (const item of reply.data) {
                                item['selected'] = false;
                                item.form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType, item, { isUpdate: true });
                            }
                            return reply.data;
                        }
                    }),
                ).subscribe((items) => {
                    this.clearSearch();
                    if (this._sort) {
                        this._sort.active = undefined;
                    }
                    this.items$.next(items);
                    this.filteredItems$.next(items);
                    this.fileLoading = false;
                });
            if (data.base64) {
                const message = '<br>' + this.transloco.translate('fileRowsProcessed') + String(data?.processed) + '<br>'
                    + this.transloco.translate('fileRowsUpdated') + String(data?.updated) + '<br>'
                    + this.transloco.translate('fileRowsCreated') + String(data?.created) + '<br>'
                    + this.transloco.translate('fileRowsDeleted') + String(data?.deleted) + '<br>'
                    + this.transloco.translate('fileRowsWithWarns') + String(data?.warns) + '<br>'
                    + this.transloco.translate('fileRowsWithErrors') + String(data?.errors) + '<br>' + '<br>'
                    + this.transloco.translate(
                        (data?.errors > 0 ? 'fileRowsWithErrorsMessage' : 'fileRowsWithoutErrorsMessage'));
                const confirm = await this.fuseConfirmDialog(this.transloco.translate((data?.errors > 0 ? 'fileProcessedWithError' : 'fileProcessed')), message, false);
                if (confirm === 'confirmed') {
                    const date = (format(new Date(), 'yyyyMMddHHmmss'));
                    const filename = (data?.errors > 0 ? 'error_' : 'loaded_') + this.localize.transform(this.masterData?.name) + '_r_' + this.repo.release + '_d_' + date;
                    const e = document.createElement('a');
                    e.href = data.base64;
                    e.target = e.target;
                    e.download = filename;
                    e.click();
                }
            } else {
                const message = '<br>' + this.transloco.translate('fileRowsProcessed') + String(data?.processed) + '<br>'
                    + this.transloco.translate('fileRowsUpdated') + String(data?.updated) + '<br>'
                    + this.transloco.translate('fileRowsCreated') + String(data?.created) + '<br>'
                    + this.transloco.translate('fileRowsDeleted') + String(data?.deleted);
                this.fuseConfirmDialog(this.transloco.translate('fileProcessed'), message, false);
            }
            this.fileLoading = false;
        } else {
            this.dialog.openErrorDialog({
                message: this.transloco.translate('dataItemCouldNotBeSaved')
            });
            this.fileLoading = false;
        }
    }

    private retrieveMasterData(request: RetrieveDTypeDataCollectionRequest) {
        return this.masterService.retrieveMasterDataDataCollection(request)
            .pipe(
                catchError((error) => {
                    console.error(error);
                    this.dialog.openErrorDialog();
                    this.loading = false;
                    return throwError(() => error);
                }),
                map((reply) => {
                    if (reply) {
                        this.totalLength = reply.count ?? 0;
                        this.eof = reply.eof;
                        this.oidsLocationChangePending = reply.extraData?.locationChangeRequest ?? [];
                        if (this.oidsLocationChangePending.length === 0) {
                            this.filterLocationChangePending = false;
                        }
                        for (const item of reply.data) {
                            item['selected'] = false;
                            item.form = this.masterService.retrieveMasterDataDtypeFormFromDtype(this.repo.payload as DType, item, { isUpdate: true });
                        }
                        return reply.data;
                    }
                }),
            )
    }

    private calculateSelectionStatus(): void {
        const items = this.filteredItems$.getValue();
        this.allSelected = items.length > 0 && items.every(item => item.selected);
        this.someSelected = items.some(item => item.selected);
        this.numSelected = items.filter(item => item.selected === true).length;
    }

    private calculateScheduleAlert() {
        this.scheduleAlert = this.transloco.translate('quarantineScheduled.part1') +
                    this.localizeDate.transform(this.repo.dtypeToGoLiveSchedule.date, 'dd/MM/yyyy H:mm') +
                    this.transloco.translate("quarantineScheduled.part2");
    }

    private confirm(title?: string, message?: string, confirm?: string, cancel?: string): Promise<'confirmed' | 'checked' | 'cancelled'> {
        const config: ConfirmationWithCheckConfig = {
            title: title ? title : this.transloco.translate('warning'),
            message: message ? message : this.transloco.translate('removeDataItemConfirm'),
            actions: {
                confirm: {
                    label: confirm ? confirm : this.transloco.translate('accept')
                },
                cancel: {
                    label: cancel ? cancel : this.transloco.translate('cancel')
                }
            },
        };


        config.check = {
            label: this.transloco.translate('physicalDelete'),
            show: true
        };

        const dialogRef = this.dialog.openConfirmWithcheckDialog(config);

        return new Promise<'confirmed' | 'checked' | 'cancelled'>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                resolve(result);
            });
        });
    }

    private isTheSameLocator(locator: string, dtypeLocator: string) {
        const split = locator.split(',');
        const dtypeSplit = dtypeLocator.split(',');
        return dtypeSplit[0] === split[0];
    }

    private fuseConfirmDialog(title?: string, message?: string, showIcon?: boolean): Promise<'confirmed'> {
        const dialogRef = this._fuseConfirmationService.open({
            title: title,
            message: message,
            actions: {
                confirm: {
                    label: this.transloco.translate('accept')
                },
                cancel: {
                    label: this.transloco.translate('cancel'),
                    show: false,
                }
            },
            icon: {
                show: showIcon ?? true
            }
        });
        return new Promise<'confirmed'>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                resolve(result);
            });
        });
    }

    private openConfirmDialogWithCountdown(title: string, message: string, countdownMessage: string) {
        const dialog = this.dialog.openConfirmWithCountdownDialog({
            title,
            message,
            countdownMessage,
            seconds: 10,
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('revert'),
                }
            },
        });

        return new Promise<boolean>((resolve) => {
            dialog.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }
    private confirmationDialog(_message: string) {
        const dialogRef = this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate(_message),
            actions: {
                confirm: {
                    label: this.transloco.translate('accept')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe(result => resolve(result === 'confirmed'));
        });
    }

    private isSearching(): boolean {
        return Boolean(this.searchControl.value) || 
            (this.filterDTypeForm?.control && !Utils.allControlsEmpty(this.filterDTypeForm?.control));
    }
}
